"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});
var on = function on(event, handler) {
	if (this._handlers[event]) {
		this._handlers[event].push(handler);
	} else {
		console.warn("Unsupported event " + event + ".");
	}
};

exports.default = on;


//////////////////
// WEBPACK FOOTER
// /home/romain/impala/web/app/themes/ewill-theme/node_modules/swup/lib/modules/on.js
// module id = 45
// module chunks = 0